import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/customer-print-template"

export const getCustomerPrintTemplate = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}